import type {CDNSrc} from '@app/components/Image';
import {useRouter} from 'next/router';

export type LocalImageConfig = {[locale: string]: CDNSrc; default: CDNSrc};
export const useLocalImage = (config: LocalImageConfig): CDNSrc => {
	const {locale} = useRouter();
	return config[locale] ?? config.default;
};
